import {
  AssessmentStatusSchema,
  type AssessmentStatus,
} from "../types/assessment.js";
import { isAssessmentStatusUnderWay } from "./isAssessmentStatusUnderWay.js";

/**
 * The statuses `isAssessmentStatusUnderWay` does not hold of, so a query selects
 * finished assessments by the same shared rule.
 */
export const assessmentStatusesFinished: readonly AssessmentStatus[] =
  AssessmentStatusSchema.options.filter(
    (status) => !isAssessmentStatusUnderWay(status),
  );
